import { render, staticRenderFns } from "./haiyaMarquee.vue?vue&type=template&id=8acf4092&scoped=true&"
import script from "./haiyaMarquee.vue?vue&type=script&lang=js&"
export * from "./haiyaMarquee.vue?vue&type=script&lang=js&"
import style0 from "./haiyaMarquee.vue?vue&type=style&index=0&id=8acf4092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8acf4092",
  null
  
)

export default component.exports